import { Geolocator, Store } from 'components/page-content/geolocator/types/geolocator';
import { Icon, IconsEnum } from 'components/Icons';
import { useEffect, useState } from 'react';

import { AnchorLink } from 'components/anchorLink';
import { SkeletonArea } from 'components/skeletonArea';
import { capitalize, isMatch, isNotEmpty } from 'utility/functions';
import styles from './GeolocatorWidget.module.scss';
import { useGetLabelsByKeys } from 'hooks/useLingUI';

export type GeolocatorWidgetProps = {
  title: string;
};

export const GeolocatorWidget = ({ title }: GeolocatorWidgetProps) => {
  const [nearestStore, setNearestStore] = useState<Store>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [labelTrovaUnNegozio, labelTrovaUnAltroNegozio, labelNoPosition] = useGetLabelsByKeys([
    'trova-un-negozio',
    'trova-un-altro-negozio',
    'no-geolocator-position',
  ]);

  useEffect(() => {
    const ck1 = isMatch(process.env.NEXT_PUBLIC_WOOSMAP_API, '^http');
    const ck2 = isNotEmpty(process.env.NEXT_PUBLIC_WOOSMAP_KEY);

    if (ck1 && ck2) {
      setIsLoading(true);
      fetch(
        `${process.env.NEXT_PUBLIC_WOOSMAP_API}/?key=${process.env.NEXT_PUBLIC_WOOSMAP_KEY}&limit=20&radius=50000`,
        {
          method: 'GET',
          redirect: 'follow',
        }
      )
        .then(async (result) => {
          const stores = ((await result.json()) as Geolocator).stores.features;
          setNearestStore(stores[0]);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log('error', error);
          setIsLoading(false);
        });
    }
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.headerWidget}>{title}</div>
      {isLoading ? (
        <SkeletonArea height="13.2" className={styles.skeleton} />
      ) : (
        <div className={`${styles.background} ${nearestStore ? styles.backgroundNear : ''}`}>
          <Icon
            iconId={IconsEnum.PINLOCATION}
            className={nearestStore ? styles.iconNear : styles.icon}
            color="var(--color-accent)"
          />
          {nearestStore ? (
            <>
              <span className={styles.textStore}>{nearestStore.properties.name}</span>
              <span className={styles.text}>{capitalize(nearestStore?.properties.address.lines[0] as string)},</span>
              <span className={styles.text}>
                {nearestStore?.properties.address.zipcode} {capitalize(nearestStore?.properties.address.city as string)}
              </span>
              <span className={styles.distance}>
                <Icon iconId={IconsEnum.TRIP} className={styles.iconDistance} color={'var(--color-on-bg-primary'} />
                {(nearestStore?.properties?.distance! / 1000).toFixed(2)}km
              </span>
            </>
          ) : (
            <span className={styles.text}>{labelNoPosition}</span>
          )}
        </div>
      )}
      <AnchorLink className={styles.href} href="/geolocator">
        {nearestStore ? labelTrovaUnAltroNegozio : labelTrovaUnNegozio}
      </AnchorLink>
    </div>
  );
};
